import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { createColumnHelper } from '@tanstack/react-table';
import { getDateFormat, isExpirationDateRisky } from '../../../../utils/date';
import Table from './Table';
import { compareDates } from '../../../../utils/sort';

import moment from '../../../../moment';
import { StudentDataEntry } from '../DashboardTable';

export type DrivingPassDataEntry = StudentDataEntry & {
	displayName: string;
	driverPassExpiryDate: string;
};

const columnHelper = createColumnHelper<DrivingPassDataEntry>();

const DrivingPass = ({ students }: { students: DrivingPassDataEntry[] }) => {
	const { t } = useTranslation();

	const columns = useMemo(
		() => [
			columnHelper.accessor('displayName', {
				header: t('dashboard.name'),
			}),
			columnHelper.accessor('driverPassExpiryDate', {
				header: t('dashboard.expiry_date'),
				cell: (info) => getDateFormat(info.cell.getValue()),
				sortingFn: (rowA, rowB) =>
					compareDates(
						moment(rowA.original.driverPassExpiryDate),
						moment(rowB.original.driverPassExpiryDate),
					),
			}),
		],
		[],
	);

	const filteredStudents = React.useMemo(() => {
		if (students === null) {
			return [];
		}

		return students.filter(({ driverPassExpiryDate }) =>
			isExpirationDateRisky(driverPassExpiryDate),
		);
	}, [students]);

	return <Table data={filteredStudents} columns={columns} />;
};

export default DrivingPass;
